import { useState, useEffect, useCallback } from 'react';
import api from '../services/api';

export function useTeam() {
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchTeam = useCallback(async () => {
    setLoading(true);
    try {
      const response = await api.get('users/');
      setMembers(response.data);
      setError(null);
    } catch (err) {
      console.error("Failed to fetch team:", err);
      setError(err.response?.data?.detail || "Failed to load team");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchTeam();
  }, [fetchTeam]);

  return {
    members,
    loading,
    error,
    refreshTeam: fetchTeam
  };
}
